import * as api from './api';
import * as types from './mutations';

const state = {
    isProcessing: false,
    membershipFeatures: {},
    memberships: {},
    plans: []
};

const getters = {

};

const actions = {
    getMembershipFeatures({state, commit}) {
        if (! _.isEmpty(state.membershipFeatures)) return;

        commit(types.SET_PROCESSING_STATE, true);
        return new Promise((resolve, reject) => {
            axios.get(api.getMembershipFeatures)
                .then(({data}) => {
                    commit(types.SET_MEMBERSHIP_FEATURES, data.membershipFeatures);
                    resolve();
                })
                .catch(({response}) => reject(response))
                .done(_ => commit(types.SET_PROCESSING_STATE, false));
        })
    },

    getMembershipType({state, commit}, {type}) {
        if (state.memberships[type]) return;

        commit(types.SET_PROCESSING_STATE, true);
        return new Promise((resolve, reject) => {
            axios.get(api.getMembershipType(type))
                .then(({data}) => {
                    commit(types.SET_MEMBERSHIPS, {type, memberships: data.memberships.data});
                    resolve();
                })
                .catch(({response}) => reject(response))
                .done(_ => commit(types.SET_PROCESSING_STATE, false));
        })
    },

    getPlans({state, commit}) {
        if (state.plans.length) return;

        return new Promise((resolve, reject) => {
            commit(types.SET_PROCESSING_STATE, true);

            axios.get(api.getPlans)
                .then(({data}) => {
                    commit(types.SET_PLANS, data.memberships.data);
                    resolve();
                })
                .catch(({response}) => reject(response))
                .done(_ => commit(types.SET_PROCESSING_STATE, false));
        });
    }
};

const mutations = {
    [types.SET_MEMBERSHIP_FEATURES](state, membershipFeatures) {
        state.membershipFeatures = membershipFeatures;
    },

    [types.SET_MEMBERSHIPS](state, {type, memberships}) {
        state.memberships[type] = memberships;
        state.memberships = _.assign({}, state.memberships);
    },

    [types.SET_PROCESSING_STATE](state, isProcessing) {
        state.isProcessing = isProcessing;
    },

    [types.SET_PLANS](state, memberships) {
        state.plans = [...memberships];
    }
};

export default {
    namespaced: true,
    getters,
    state,
    actions,
    mutations
};